import type { JSX } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';
import { failureFrom } from '@/lib/result';
import { ErrorState } from '../shell/states';

/**
 * What the thread shows instead of messages while a conversation loads or
 * when it cannot be read — or nothing, and the messages (or the empty state)
 * speak for themselves.
 */
export function threadStatus(
  query: UseQueryResult<unknown>,
  active: boolean,
): JSX.Element | undefined {
  if (!active) return undefined;
  if (query.isPending) {
    return (
      <div className="flex flex-col gap-4" aria-busy="true" aria-label="Loading">
        <div className="skeleton ml-auto h-10 w-[46%] rounded-[14px]" />
        <div className="skeleton h-24 w-[78%] rounded-xl" />
      </div>
    );
  }
  if (query.isError) {
    const { status, detail } = failureFrom(query.error);
    return <ErrorState status={status} detail={detail} onRetry={() => void query.refetch()} />;
  }
  return undefined;
}
